import { LocationJson, LocationType } from 'app/types/entities'
import { isLocationIntegrated } from 'app/utils'
import { businessDaysDiff } from 'lib/businessDays'

export function getLocationIntegrationStatus(
  location: LocationJson | LocationType,
): `integrated` | `missingData` | `notIntegrated` {
  if (!isLocationIntegrated(location)) return `notIntegrated`
  if (location?.lastPmsSyncDate && Math.abs(businessDaysDiff(new Date(location.lastPmsSyncDate), new Date())) <= 2) {
    return `integrated`
  }
  return `missingData`
}
